export default __webpack_public_path__ + "static/media/eucalyptus-icon.72c31b13.svg";